import {
  CompareConfigItem,
  isNotEqual,
  optionalStringsDiffer,
  useGeoEvent,
  UseGeoEventEditableResult,
} from 'features/geoEvents/hooks/useGeoEvent';
import { Hazard, HazardCreateUpdateData } from '../../hazard.types';

export type UseHazardGeoEventProps = {
  id?: number;
  enabled?: boolean;
};

export type UseHazardGeoEvent = UseGeoEventEditableResult<
  Hazard,
  HazardCreateUpdateData
>;

/**
 * Hazard-specific data field configurations for constructPatch
 */
export const hazardDataPatchConfigs: Record<
  keyof HazardCreateUpdateData['data'],
  CompareConfigItem
> = {
  hazardType: {
    shouldPatch: isNotEqual,
  },
  information: {
    shouldPatch: optionalStringsDiffer,
  },
  links: {
    shouldPatch: isNotEqual,
  },
  // This field is never sent with PATCH
  geoEventType: { shouldPatch: () => false },
};

/**
 * Hazard-specific geo event hook.
 * Uses hazard data patch configs for patch operations.
 */
export const useHazardGeoEvent = (
  props: UseHazardGeoEventProps,
): UseHazardGeoEvent => {
  return useGeoEvent<Hazard, HazardCreateUpdateData>({
    ...props,
    dataPatchConfigs: hazardDataPatchConfigs,
  });
};
